import UserPermissionTypes from '@constants/permissions';
import { PaymentOrderActionAccess } from '@features/transactions/helpers/transactionRowActions';
import useCheckPermission from '@hooks/checkPermission';

const usePaymentOrderActionAccess = (): PaymentOrderActionAccess => {
  const { checkPermission } = useCheckPermission();

  return {
    canMarkAsPaid: checkPermission([
      UserPermissionTypes.PAYMENT_ORDER_MARK_PAID
    ]),
    canCreateDiscount: checkPermission([
      UserPermissionTypes.PAYMENT_ORDER_DISCOUNT_CREATE
    ]),
    canClosePayment: checkPermission([UserPermissionTypes.PAYMENT_ORDER_CLOSE]),
    canEnablePartialPayment: checkPermission([
      UserPermissionTypes.PAYMENT_ORDER_SPLIT_ENABLE
    ]),
    canDisable: checkPermission([UserPermissionTypes.PAYMENT_ORDER_DISABLE]),
    canSendReminder: checkPermission([
      UserPermissionTypes.PAYMENT_ORDER_SEND_REMINDER
    ])
  };
};

export type { PaymentOrderActionAccess };
export default usePaymentOrderActionAccess;
